var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _g2, _path437, _g3, _path438, _g4, _path439, _g5, _path440, _g6, _path441, _g7, _path442, _g8, _path443, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_542_299895)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 78,
    height: 78,
    fill: "white",
    fillOpacity: 0.64,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_299895)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9196 3.09814H6.59961V74.5201H79.9196V3.09814Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3446 6.9585H32.3623V8.88944H34.3446V6.9585Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 6.9585H38.3057V8.88944H40.2879V6.9585Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 6.9585H40.2871V8.88944H42.2694V6.9585Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 6.9585H42.2695V8.88944H44.2518V6.9585Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 6.9585H44.25V8.88944H46.2323V6.9585Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 6.9585H46.2305V8.88944H48.2127V6.9585Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 6.9585H48.2129V8.88944H50.1951V6.9585Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 6.9585H52.1758V8.88944H54.158V6.9585Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 6.9585H54.1582V8.88944H56.1405V6.9585Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 6.9585H58.1211V8.88944H60.1034V6.9585Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 8.88965H28.3975V10.8206H30.3797V8.88965Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 8.88965H30.3799V10.8206H32.3621V8.88965Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 8.88965H32.3613V10.8206H34.3436V8.88965Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 8.88965H34.3418V10.8206H36.3241V8.88965Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 8.88965H38.3057V10.8206H40.2879V8.88965Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 8.88965H40.2871V10.8206H42.2694V8.88965Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 8.88965H46.2305V10.8206H48.2127V8.88965Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 8.88965H48.2129V10.8206H50.1951V8.88965Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 8.88965H50.1953V10.8206H52.1776V8.88965Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 8.88965H52.1758V10.8206H54.158V8.88965Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 8.88965H58.1211V10.8206H60.1034V8.88965Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 10.8198H26.417V12.7508H28.3992V10.8198Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 10.8198H28.3975V12.7508H30.3797V10.8198Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 10.8198H30.3799V12.7508H32.3621V10.8198Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 10.8198H36.3242V12.7508H38.3065V10.8198Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 10.8198H38.3057V12.7508H40.2879V10.8198Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 10.8198H40.2871V12.7508H42.2694V10.8198Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2332 10.8198H44.251V12.7508H46.2332V10.8198Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 10.8198H46.2305V12.7508H48.2127V10.8198Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 10.8198H48.2129V12.7508H50.1951V10.8198Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 10.8198H52.1758V12.7508H54.158V10.8198Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 10.8198H54.1582V12.7508H56.1405V10.8198Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 10.8198H56.1406V12.7508H58.1229V10.8198Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 10.8198H58.1211V12.7508H60.1034V10.8198Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 12.749H26.417V14.68H28.3992V12.749Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 12.749H36.3242V14.68H38.3065V12.749Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 12.749H40.2871V14.68H42.2694V12.749Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 12.749H44.25V14.68H46.2323V12.749Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 12.7495H46.2305V14.6805H48.2127V12.7495Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 12.7495H50.1953V14.6805H52.1776V12.7495Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 12.7495H52.1758V14.6805H54.158V12.7495Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 12.749H56.1406V14.68H58.1229V12.749Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 12.749H58.1211V14.68H60.1034V12.749Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 14.6802H28.3975V16.6111H30.3797V14.6802Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 14.6802H30.3799V16.6111H32.3621V14.6802Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3446 14.6802H32.3623V16.6111H34.3446V14.6802Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 14.6802H34.3418V16.6111H36.3241V14.6802Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 14.6802H36.3242V16.6111H38.3065V14.6802Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 14.6802H40.2871V16.6111H42.2694V14.6802Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 14.6802H42.2695V16.6111H44.2518V14.6802Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 14.6802H44.25V16.6111H46.2323V14.6802Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 14.6802H46.2305V16.6111H48.2127V14.6802Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 14.6802H48.2129V16.6111H50.1951V14.6802Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 14.6802H52.1758V16.6111H54.158V14.6802Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 14.6802H56.1406V16.6111H58.1229V14.6802Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 16.6113H28.3975V18.5423H30.3797V16.6113Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 16.6113H30.3799V18.5423H32.3621V16.6113Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 16.6113H34.3418V18.5423H36.3241V16.6113Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 16.6113H36.3242V18.5423H38.3065V16.6113Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 16.6113H38.3057V18.5423H40.2879V16.6113Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 16.6113H48.2129V18.5423H50.1951V16.6113Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 16.6113H54.1582V18.5423H56.1405V16.6113Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 16.6113H58.1211V18.5423H60.1034V16.6113Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 18.54H26.417V20.471H28.3992V18.54Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 18.54H30.3799V20.471H32.3621V18.54Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 18.54H34.3418V20.471H36.3241V18.54Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 18.54H38.3057V20.471H40.2879V18.54Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 18.54H42.2695V20.471H44.2518V18.54Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 18.54H46.2305V20.471H48.2127V18.54Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 18.54H50.1953V20.471H52.1776V18.54Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 18.54H54.1582V20.471H56.1405V18.54Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 18.54H58.1211V20.471H60.1034V18.54Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 20.4712H28.3975V22.4021H30.3797V20.4712Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 20.4712H30.3799V22.4021H32.3621V20.4712Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 20.4712H34.3418V22.4021H36.3241V20.4712Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 20.4712H40.2871V22.4021H42.2694V20.4712Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 20.4712H42.2695V22.4021H44.2518V20.4712Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 20.4712H54.1582V22.4021H56.1405V20.4712Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 20.4712H56.1406V22.4021H58.1229V20.4712Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 22.4019H16.5068V24.3328H18.4891V22.4019Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4715 22.4019H18.4893V24.3328H20.4715V22.4019Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 22.4019H22.4521V24.3328H24.4344V22.4019Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 22.4019H24.4346V24.3328H26.4168V22.4019Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 22.4019H28.3975V24.3328H30.3797V22.4019Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3446 22.4019H32.3623V24.3328H34.3446V22.4019Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 22.4019H42.2695V24.3328H44.2518V22.4019Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 22.4019H46.2305V24.3328H48.2127V22.4019Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 22.4019H56.1406V24.3328H58.1229V22.4019Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 22.4019H58.1211V24.3328H60.1034V22.4019Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 22.4019H68.0303V24.3328H70.0125V22.4019Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 22.4019H70.0107V24.3328H71.993V22.4019Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 24.3311H10.5625V26.262H12.5448V24.3311Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 24.3311H14.5273V26.262H16.5096V24.3311Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 24.3311H16.5068V26.262H18.4891V24.3311Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 24.3311H20.4717V26.262H22.4539V24.3311Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 24.3311H26.417V26.262H28.3992V24.3311Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 24.3311H28.3975V26.262H30.3797V24.3311Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 24.3311H30.3799V26.262H32.3621V24.3311Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 24.3311H32.3613V26.262H34.3436V24.3311Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 24.3311H34.3418V26.262H36.3241V24.3311Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 24.3311H40.2871V26.262H42.2694V24.3311Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 24.3311H46.2305V26.262H48.2127V24.3311Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 24.3311H48.2129V26.262H50.1951V24.3311Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 24.3311H50.1953V26.262H52.1776V24.3311Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 24.3311H56.1406V26.262H58.1229V24.3311Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 24.3311H60.1035V26.262H62.0858V24.3311Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 24.3311H64.0664V26.262H66.0487V24.3311Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 24.3311H66.0488V26.262H68.0311V24.3311Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 24.3311H68.0303V26.262H70.0125V24.3311Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 24.3311H70.0107V26.262H71.993V24.3311Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 26.2617H10.5625V28.1927H12.5448V26.2617Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 26.2617H22.4521V28.1927H24.4344V26.2617Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 26.2617H26.417V28.1927H28.3992V26.2617Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 26.2617H28.3975V28.1927H30.3797V26.2617Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 26.2617H30.3799V28.1927H32.3621V26.2617Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 26.2617H38.3057V28.1927H40.2879V26.2617Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 26.2617H42.2695V28.1927H44.2518V26.2617Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2332 26.2617H44.251V28.1927H46.2332V26.2617Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 26.2617H52.1758V28.1927H54.158V26.2617Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 26.2617H56.1406V28.1927H58.1229V26.2617Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 26.2617H60.1035V28.1927H62.0858V26.2617Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 26.2617H62.0859V28.1927H64.0682V26.2617Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 26.2617H64.0664V28.1927H66.0487V26.2617Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 26.2617H70.0107V28.1927H71.993V26.2617Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 26.2617H71.9932V28.1927H73.9754V26.2617Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 26.2617H73.9756V28.1927H75.9578V26.2617Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 28.1929H14.5273V30.1238H16.5096V28.1929Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 28.1929H16.5068V30.1238H18.4891V28.1929Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 28.1929H24.4346V30.1238H26.4168V28.1929Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 28.1929H26.417V30.1238H28.3992V28.1929Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 28.1929H30.3799V30.1238H32.3621V28.1929Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 28.1929H40.2871V30.1238H42.2694V28.1929Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 28.1929H44.25V30.1238H46.2323V28.1929Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 28.1929H50.1953V30.1238H52.1776V28.1929Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 28.1929H58.1211V30.1238H60.1034V28.1929Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 28.1929H60.1035V30.1238H62.0858V28.1929Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 28.1929H64.0664V30.1238H66.0487V28.1929Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 28.1929H66.0479V30.1238H68.0301V28.1929Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 28.1929H68.0303V30.1238H70.0125V28.1929Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 28.1929H70.0107V30.1238H71.993V28.1929Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 28.1929H71.9932V30.1238H73.9754V28.1929Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 30.1221H10.5625V32.053H12.5448V30.1221Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 30.1221H12.5449V32.053H14.5272V30.1221Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 30.1221H14.5273V32.053H16.5096V30.1221Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 30.1221H16.5068V32.053H18.4891V30.1221Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 30.1221H20.4717V32.053H22.4539V30.1221Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 30.1221H22.4521V32.053H24.4344V30.1221Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 30.1221H24.4346V32.053H26.4168V30.1221Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 30.1221H54.1582V32.053H56.1405V30.1221Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 30.1221H56.1406V32.053H58.1229V30.1221Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 30.1221H62.0859V32.053H64.0682V30.1221Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 30.1221H64.0664V32.053H66.0487V30.1221Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 30.1221H68.0303V32.053H70.0125V30.1221Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 30.1221H73.9756V32.053H75.9578V30.1221Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 32.0532H10.5625V33.9842H12.5448V32.0532Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 32.0532H16.5068V33.9842H18.4891V32.0532Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 32.0532H26.417V33.9842H28.3992V32.0532Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 32.0532H54.1582V33.9842H56.1405V32.0532Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 32.0532H56.1406V33.9842H58.1229V32.0532Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 32.0532H64.0664V33.9842H66.0487V32.0532Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 32.0532H71.9932V33.9842H73.9754V32.0532Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 33.9839H10.5625V35.9148H12.5448V33.9839Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 33.9839H16.5068V35.9148H18.4891V33.9839Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 33.9839H20.4717V35.9148H22.4539V33.9839Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 33.9839H22.4521V35.9148H24.4344V33.9839Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 33.9839H24.4346V35.9148H26.4168V33.9839Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 33.9839H26.417V35.9148H28.3992V33.9839Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 33.9839H30.3799V35.9148H32.3621V33.9839Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 33.9839H58.1211V35.9148H60.1034V33.9839Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 35.9131H10.5625V37.844H12.5448V35.9131Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 35.9131H12.5449V37.844H14.5272V35.9131Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 35.9131H14.5273V37.844H16.5096V35.9131Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 35.9131H16.5068V37.844H18.4891V35.9131Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4715 35.9131H18.4893V37.844H20.4715V35.9131Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 35.9131H24.4346V37.844H26.4168V35.9131Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 35.9131H58.1211V37.844H60.1034V35.9131Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 35.9131H60.1035V37.844H62.0858V35.9131Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 35.9131H62.0859V37.844H64.0682V35.9131Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 35.9131H66.0479V37.844H68.0301V35.9131Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 35.9131H70.0107V37.844H71.993V35.9131Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 35.9131H71.9932V37.844H73.9754V35.9131Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 37.8438H10.5625V39.7747H12.5448V37.8438Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 37.8438H12.5449V39.7747H14.5272V37.8438Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 37.8442H20.4717V39.7752H22.4539V37.8442Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 37.8438H22.4521V39.7747H24.4344V37.8438Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 37.8442H26.417V39.7752H28.3992V37.8442Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 37.8438H56.1406V39.7747H58.1229V37.8438Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 37.8438H60.1035V39.7747H62.0858V37.8438Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 37.8442H62.0859V39.7752H64.0682V37.8442Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 37.8442H64.0664V39.7752H66.0487V37.8442Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 37.8438H66.0479V39.7747H68.0301V37.8438Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 37.8438H68.0303V39.7747H70.0125V37.8438Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 37.8438H71.9932V39.7747H73.9754V37.8438Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 39.7749H12.5449V41.7059H14.5272V39.7749Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 39.7749H16.5068V41.7059H18.4891V39.7749Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 39.7749H20.4717V41.7059H22.4539V39.7749Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 39.7754H26.417V41.7063H28.3992V39.7754Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 39.7749H28.3975V41.7059H30.3797V39.7749Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 39.7749H30.3799V41.7059H32.3621V39.7749Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 39.7749H54.1582V41.7059H56.1405V39.7749Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 39.7749H58.1211V41.7059H60.1034V39.7749Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 39.7749H62.0859V41.7059H64.0682V39.7749Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 39.7749H64.0664V41.7059H66.0487V39.7749Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 39.7749H66.0488V41.7059H68.0311V39.7749Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 39.7749H68.0303V41.7059H70.0125V39.7749Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 39.7749H71.9932V41.7059H73.9754V39.7749Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 39.7754H73.9756V41.7063H75.9578V39.7754Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 41.7041H10.5625V43.635H12.5448V41.7041Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 41.7041H12.5449V43.635H14.5272V41.7041Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 41.7041H14.5273V43.635H16.5096V41.7041Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 41.7041H20.4717V43.635H22.4539V41.7041Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 41.7041H22.4521V43.635H24.4344V41.7041Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 41.7041H24.4346V43.635H26.4168V41.7041Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 41.7041H30.3799V43.635H32.3621V41.7041Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 41.7041H54.1582V43.635H56.1405V41.7041Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 41.7041H56.1406V43.635H58.1229V41.7041Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 41.7041H64.0664V43.635H66.0487V41.7041Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 41.7041H68.0303V43.635H70.0125V41.7041Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 41.7041H70.0107V43.635H71.993V41.7041Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 41.7041H73.9756V43.635H75.9578V41.7041Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 43.6348H12.5449V45.5657H14.5272V43.6348Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 43.6348H14.5273V45.5657H16.5096V43.6348Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 43.6348H20.4717V45.5657H22.4539V43.6348Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 43.6348H28.3975V45.5657H30.3797V43.6348Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 43.6348H30.3799V45.5657H32.3621V43.6348Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 43.6348H54.1582V45.5657H56.1405V43.6348Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 43.6348H56.1406V45.5657H58.1229V43.6348Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 43.6348H58.1211V45.5657H60.1034V43.6348Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 43.6348H64.0664V45.5657H66.0487V43.6348Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 43.6348H66.0479V45.5657H68.0301V43.6348Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 43.6348H68.0303V45.5657H70.0125V43.6348Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 43.6348H70.0107V45.5657H71.993V43.6348Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 43.6348H71.9932V45.5657H73.9754V43.6348Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 43.6348H73.9756V45.5657H75.9578V43.6348Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 45.5659H10.5625V47.4969H12.5448V45.5659Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 45.5659H12.5449V47.4969H14.5272V45.5659Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 45.5659H16.5068V47.4969H18.4891V45.5659Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 45.5659H22.4521V47.4969H24.4344V45.5659Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 45.5659H24.4346V47.4969H26.4168V45.5659Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 45.5659H58.1211V47.4969H60.1034V45.5659Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 45.5659H64.0664V47.4969H66.0487V45.5659Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 45.5659H68.0303V47.4969H70.0125V45.5659Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 47.4946H10.5625V49.4255H12.5448V47.4946Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 47.4946H12.5449V49.4255H14.5272V47.4946Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 47.4946H16.5068V49.4255H18.4891V47.4946Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4715 47.4946H18.4893V49.4255H20.4715V47.4946Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 47.4946H28.3975V49.4255H30.3797V47.4946Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 47.4946H34.3418V49.4255H36.3241V47.4946Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 47.4946H36.3242V49.4255H38.3065V47.4946Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 47.4946H38.3057V49.4255H40.2879V47.4946Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2332 47.4946H44.251V49.4255H46.2332V47.4946Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 47.4946H46.2305V49.4255H48.2127V47.4946Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 47.4946H48.2129V49.4255H50.1951V47.4946Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 47.4946H50.1953V49.4255H52.1776V47.4946Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 47.4946H58.1211V49.4255H60.1034V47.4946Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 47.4946H64.0664V49.4255H66.0487V47.4946Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 47.4946H66.0488V49.4255H68.0311V47.4946Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 47.4946H68.0303V49.4255H70.0125V47.4946Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 49.4258H10.5625V51.3567H12.5448V49.4258Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 49.4258H14.5273V51.3567H16.5096V49.4258Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 49.4258H22.4521V51.3567H24.4344V49.4258Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 49.4258H30.3799V51.3567H32.3621V49.4258Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3446 49.4258H32.3623V51.3567H34.3446V49.4258Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 49.4258H34.3418V51.3567H36.3241V49.4258Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 49.4258H36.3242V51.3567H38.3065V49.4258Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 49.4258H38.3057V51.3567H40.2879V49.4258Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 49.4258H42.2695V51.3567H44.2518V49.4258Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 49.4258H44.25V51.3567H46.2323V49.4258Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 49.4258H56.1406V51.3567H58.1229V49.4258Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 49.4258H62.0859V51.3567H64.0682V49.4258Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 49.4258H64.0664V51.3567H66.0487V49.4258Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 49.4258H68.0303V51.3567H70.0125V49.4258Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 49.4258H71.9932V51.3567H73.9754V49.4258Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 49.4258H73.9756V51.3567H75.9578V49.4258Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 51.3569H10.5625V53.2879H12.5448V51.3569Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4891 51.3569H16.5068V53.2879H18.4891V51.3569Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 51.3569H26.417V53.2879H28.3992V51.3569Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 51.3569H34.3418V53.2879H36.3241V51.3569Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 51.3569H40.2871V53.2879H42.2694V51.3569Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 51.3569H42.2695V53.2879H44.2518V51.3569Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 51.3569H48.2129V53.2879H50.1951V51.3569Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 51.3569H54.1582V53.2879H56.1405V51.3569Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 51.3569H56.1406V53.2879H58.1229V51.3569Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 51.3569H64.0664V53.2879H66.0487V51.3569Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 51.3569H66.0479V53.2879H68.0301V51.3569Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 51.3569H70.0107V53.2879H71.993V51.3569Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 51.3569H71.9932V53.2879H73.9754V51.3569Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 51.3569H73.9756V53.2879H75.9578V51.3569Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5448 53.2861H10.5625V55.2171H12.5448V53.2861Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 53.2861H12.5449V55.2171H14.5272V53.2861Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 53.2861H14.5273V55.2171H16.5096V53.2861Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4715 53.2861H18.4893V55.2171H20.4715V53.2861Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 53.2861H20.4717V55.2171H22.4539V53.2861Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4344 53.2861H22.4521V55.2171H24.4344V53.2861Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4168 53.2861H24.4346V55.2171H26.4168V53.2861Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 53.2861H26.417V55.2171H28.3992V53.2861Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 53.2861H32.3613V55.2171H34.3436V53.2861Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 53.2861H34.3418V55.2171H36.3241V53.2861Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 53.2861H36.3242V55.2171H38.3065V53.2861Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 53.2861H38.3057V55.2171H40.2879V53.2861Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 53.2861H40.2871V55.2171H42.2694V53.2861Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 53.2861H46.2305V55.2171H48.2127V53.2861Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 53.2861H48.2129V55.2171H50.1951V53.2861Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 53.2861H58.1211V55.2171H60.1034V53.2861Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 53.2861H60.1035V55.2171H62.0858V53.2861Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 53.2861H62.0859V55.2171H64.0682V53.2861Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 53.2861H64.0664V55.2171H66.0487V53.2861Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 53.2861H66.0488V55.2171H68.0311V53.2861Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 53.2861H71.9932V55.2171H73.9754V53.2861Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 53.2861H73.9756V55.2171H75.9578V53.2861Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 55.2168H26.417V57.1477H28.3992V55.2168Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 55.2168H28.3975V57.1477H30.3797V55.2168Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 55.2168H30.3799V57.1477H32.3621V55.2168Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 55.2168H32.3613V57.1477H34.3436V55.2168Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 55.2168H36.3242V57.1477H38.3065V55.2168Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 55.2168H38.3057V57.1477H40.2879V55.2168Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 55.2168H42.2695V57.1477H44.2518V55.2168Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 55.2168H46.2305V57.1477H48.2127V55.2168Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 55.2168H48.2129V57.1477H50.1951V55.2168Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 55.2163H50.1953V57.1473H52.1776V55.2163Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 55.2168H52.1758V57.1477H54.158V55.2168Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 55.2168H58.1211V57.1477H60.1034V55.2168Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 55.2168H66.0488V57.1477H68.0311V55.2168Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 55.2168H68.0303V57.1477H70.0125V55.2168Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 55.2168H71.9932V57.1477H73.9754V55.2168Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 57.1475H26.417V59.0784H28.3992V57.1475Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 57.1475H34.3418V59.0784H36.3241V57.1475Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 57.1475H36.3242V59.0784H38.3065V57.1475Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 57.1475H38.3057V59.0784H40.2879V57.1475Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 57.1475H40.2871V59.0784H42.2694V57.1475Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 57.1475H42.2695V59.0784H44.2518V57.1475Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 57.1475H46.2305V59.0784H48.2127V57.1475Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 57.1475H50.1953V59.0784H52.1776V57.1475Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 57.1475H56.1406V59.0784H58.1229V57.1475Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 57.1475H58.1211V59.0784H60.1034V57.1475Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 57.1475H62.0859V59.0784H64.0682V57.1475Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 57.1475H66.0488V59.0784H68.0311V57.1475Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 59.0767H28.3975V61.0076H30.3797V59.0767Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 59.0767H30.3799V61.0076H32.3621V59.0767Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 59.0767H36.3242V61.0076H38.3065V59.0767Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 59.0767H38.3057V61.0076H40.2879V59.0767Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 59.0767H40.2871V61.0076H42.2694V59.0767Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 59.0771H46.2305V61.0081H48.2127V59.0771Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 59.0767H52.1758V61.0076H54.158V59.0767Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 59.0767H54.1582V61.0076H56.1405V59.0767Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 59.0767H56.1406V61.0076H58.1229V59.0767Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 59.0767H58.1211V61.0076H60.1034V59.0767Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 59.0767H66.0479V61.0076H68.0301V59.0767Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 59.0767H68.0303V61.0076H70.0125V59.0767Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 59.0767H70.0107V61.0076H71.993V59.0767Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 59.0767H71.9932V61.0076H73.9754V59.0767Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 61.0078H26.417V62.9388H28.3992V61.0078Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 61.0078H28.3975V62.9388H30.3797V61.0078Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 61.0078H30.3799V62.9388H32.3621V61.0078Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 61.0078H32.3613V62.9388H34.3436V61.0078Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 61.0078H34.3418V62.9388H36.3241V61.0078Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 61.0078H36.3242V62.9388H38.3065V61.0078Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 61.0078H40.2871V62.9388H42.2694V61.0078Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2332 61.0078H44.251V62.9388H46.2332V61.0078Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 61.0078H46.2305V62.9388H48.2127V61.0078Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 61.0078H48.2129V62.9388H50.1951V61.0078Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 61.0078H52.1758V62.9388H54.158V61.0078Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 61.0078H54.1582V62.9388H56.1405V61.0078Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 61.0078H56.1406V62.9388H58.1229V61.0078Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 61.0078H58.1211V62.9388H60.1034V61.0078Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 61.0078H60.1035V62.9388H62.0858V61.0078Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 61.0078H62.0859V62.9388H64.0682V61.0078Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 61.0078H64.0664V62.9388H66.0487V61.0078Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0311 61.0078H66.0488V62.9388H68.0311V61.0078Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 61.0078H68.0303V62.9388H70.0125V61.0078Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 61.0078H71.9932V62.9388H73.9754V61.0078Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3992 62.939H26.417V64.8699H28.3992V62.939Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 62.939H28.3975V64.8699H30.3797V62.939Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3621 62.939H30.3799V64.8699H32.3621V62.939Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3436 62.939H32.3613V64.8699H34.3436V62.939Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 62.939H34.3418V64.8699H36.3241V62.939Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 62.939H36.3242V64.8699H38.3065V62.939Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 62.939H38.3057V64.8699H40.2879V62.939Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 62.939H40.2871V64.8699H42.2694V62.939Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 62.939H42.2695V64.8699H44.2518V62.939Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2332 62.939H44.251V64.8699H46.2332V62.939Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 62.939H48.2129V64.8699H50.1951V62.939Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 62.939H52.1758V64.8699H54.158V62.939Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 62.939H54.1582V64.8699H56.1405V62.939Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 62.939H60.1035V64.8699H62.0858V62.939Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 62.939H64.0664V64.8699H66.0487V62.939Z",
    fill: "black"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 62.939H71.9932V64.8699H73.9754V62.939Z",
    fill: "black"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 64.8677H34.3418V66.7986H36.3241V64.8677Z",
    fill: "black"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 64.8677H36.3242V66.7986H38.3065V64.8677Z",
    fill: "black"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 64.8677H40.2871V66.7986H42.2694V64.8677Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 64.8677H46.2305V66.7986H48.2127V64.8677Z",
    fill: "black"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 64.8677H50.1953V66.7986H52.1776V64.8677Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 64.8677H52.1758V66.7986H54.158V64.8677Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 64.8677H54.1582V66.7986H56.1405V64.8677Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 64.8677H66.0479V66.7986H68.0301V64.8677Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 64.8677H68.0303V66.7986H70.0125V64.8677Z",
    fill: "black"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 64.8677H71.9932V66.7986H73.9754V64.8677Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 64.8677H73.9756V66.7986H75.9578V64.8677Z",
    fill: "black"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3446 66.7988H32.3623V68.7298H34.3446V66.7988Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 66.7988H34.3418V68.7298H36.3241V66.7988Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 66.7988H42.2695V68.7298H44.2518V66.7988Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 66.7988H44.25V68.7298H46.2323V66.7988Z",
    fill: "black"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2127 66.7988H46.2305V68.7298H48.2127V66.7988Z",
    fill: "black"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M54.158 66.7988H52.1758V68.7298H54.158V66.7988Z",
    fill: "black"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 66.7988H54.1582V68.7298H56.1405V66.7988Z",
    fill: "black"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 66.7988H56.1406V68.7298H58.1229V66.7988Z",
    fill: "black"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 66.7988H60.1035V68.7298H62.0858V66.7988Z",
    fill: "black"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 66.7988H62.0859V68.7298H64.0682V66.7988Z",
    fill: "black"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0125 66.7988H68.0303V68.7298H70.0125V66.7988Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M71.993 66.7988H70.0107V68.7298H71.993V66.7988Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9754 66.7988H71.9932V68.7298H73.9754V66.7988Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 66.7988H73.9756V68.7298H75.9578V66.7988Z",
    fill: "black"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3446 68.7295H32.3623V70.6604H34.3446V68.7295Z",
    fill: "black"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3241 68.7295H34.3418V70.6604H36.3241V68.7295Z",
    fill: "black"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3065 68.7295H36.3242V70.6604H38.3065V68.7295Z",
    fill: "black"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2879 68.7295H38.3057V70.6604H40.2879V68.7295Z",
    fill: "black"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2694 68.73H40.2871V70.6609H42.2694V68.73Z",
    fill: "black"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2518 68.73H42.2695V70.6609H44.2518V68.73Z",
    fill: "black"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 68.7295H44.25V70.6604H46.2323V68.7295Z",
    fill: "black"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 68.7295H48.2129V70.6604H50.1951V68.7295Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 68.7295H50.1953V70.6604H52.1776V68.7295Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1405 68.7295H54.1582V70.6604H56.1405V68.7295Z",
    fill: "black"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1229 68.7295H56.1406V70.6604H58.1229V68.7295Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 68.7295H58.1211V70.6604H60.1034V68.7295Z",
    fill: "black"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0858 68.7295H60.1035V70.6604H62.0858V68.7295Z",
    fill: "black"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0682 68.7295H62.0859V70.6604H64.0682V68.7295Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0301 68.7295H66.0479V70.6604H68.0301V68.7295Z",
    fill: "black"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M22.353 6.95264H12.648H10.5693V8.9775V18.4312V20.4561H12.648H22.353H24.4316V18.4312V8.9775V6.95264H22.353ZM22.353 18.4444H12.648V8.99064H22.353V18.4444Z",
    fill: "black"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8735 6.95264H64.1685H62.0898V8.9775V18.4312V20.4561H64.1685H73.8735H75.9522V18.4312V8.9775V6.95264H73.8735ZM73.8735 18.4444H64.1685V8.99064H73.8735V18.4444Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3549 57.1514H12.65H10.5713V59.1762V68.63V70.6548H12.65H22.3549H24.4336V68.63V59.1762V57.1514H22.3549ZM22.3549 68.63H12.65V59.1762H22.3549V68.63Z",
    fill: "black"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4741 10.8198H14.5273V16.6127H20.4741V10.8198Z",
    fill: "black"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9975 10.8198H66.0508V16.6127H71.9975V10.8198Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4741 61.0098H14.5273V66.8026H20.4741V61.0098Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_542_299895)"
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4256 42.6723C39.4256 42.7658 39.4108 42.8478 39.3842 42.9126C39.3571 42.9775 39.3219 43.0326 39.2786 43.0738C39.2348 43.1169 39.1854 43.146 39.1316 43.165C39.0755 43.184 39.0217 43.1937 38.9679 43.1937H38.6221C38.5146 43.1937 38.419 43.1817 38.3362 43.1553C38.2553 43.1289 38.1787 43.083 38.104 43.0159C38.0317 42.9487 37.957 42.8575 37.8843 42.7417C37.812 42.6264 37.733 42.475 37.6502 42.2925L35.2507 37.1093C35.1241 36.8425 34.9981 36.5614 34.8715 36.2683C34.7431 35.9751 34.6251 35.6889 34.5152 35.4129H34.5029C34.5109 35.7491 34.5176 36.0955 34.5214 36.4484C34.5257 36.7995 34.5276 37.15 34.5276 37.496V42.9964C34.5276 43.0303 34.5195 43.0613 34.5029 43.0928C34.4843 43.1215 34.4553 43.1456 34.4158 43.1622C34.3744 43.1789 34.3226 43.1933 34.2564 43.2053C34.1903 43.2174 34.1052 43.222 34.0038 43.222C33.9001 43.222 33.8154 43.2174 33.7488 43.2053C33.6827 43.1933 33.6309 43.1789 33.5933 43.1622C33.5538 43.1456 33.5272 43.1215 33.5081 43.0928C33.4915 43.0617 33.4834 43.0303 33.4834 42.9969V34.5885C33.4834 34.401 33.5291 34.2667 33.6223 34.187C33.7132 34.1078 33.8131 34.0671 33.9225 34.0671H34.4363C34.5566 34.0671 34.6579 34.0791 34.7388 34.1032C34.8216 34.125 34.8944 34.1657 34.9586 34.2185C35.0228 34.2713 35.087 34.3482 35.147 34.4445C35.2069 34.5408 35.2711 34.6608 35.3377 34.8076L37.1816 38.8062C37.2958 39.0511 37.4052 39.2892 37.5108 39.5221C37.6164 39.7551 37.7201 39.9834 37.8177 40.2094C37.9152 40.4331 38.0122 40.6563 38.1079 40.8749C38.2054 41.0912 38.2986 41.3121 38.3938 41.5335H38.3999C38.3919 41.1611 38.3852 40.7763 38.3833 40.3752C38.3814 39.9737 38.3814 39.587 38.3814 39.2169V34.2782C38.3814 34.2444 38.3895 34.2134 38.4061 34.187C38.4247 34.1583 38.4537 34.1342 38.4932 34.1125C38.5346 34.0907 38.5883 34.0763 38.6525 34.0666C38.7187 34.0569 38.8057 34.0522 38.9137 34.0522C39.007 34.0522 39.0878 34.0569 39.1563 34.0666C39.2248 34.0763 39.2786 34.0907 39.3157 34.1125C39.3552 34.1342 39.3818 34.1583 39.4009 34.187C39.4175 34.2134 39.4256 34.2449 39.4256 34.2782V42.6723Z",
    fill: "url(#paint0_linear_542_299895)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 34,
    width: 7,
    height: 10
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4256 42.6723C39.4256 42.7658 39.4108 42.8478 39.3842 42.9126C39.3571 42.9775 39.3219 43.0326 39.2786 43.0738C39.2348 43.1169 39.1854 43.146 39.1316 43.165C39.0755 43.184 39.0217 43.1937 38.9679 43.1937H38.6221C38.5146 43.1937 38.419 43.1817 38.3362 43.1553C38.2553 43.1289 38.1787 43.083 38.104 43.0159C38.0317 42.9487 37.957 42.8575 37.8843 42.7417C37.812 42.6264 37.733 42.475 37.6502 42.2925L35.2507 37.1093C35.1241 36.8425 34.9981 36.5614 34.8715 36.2683C34.7431 35.9751 34.6251 35.6889 34.5152 35.4129H34.5029C34.5109 35.7491 34.5176 36.0955 34.5214 36.4484C34.5257 36.7995 34.5276 37.15 34.5276 37.496V42.9964C34.5276 43.0303 34.5195 43.0613 34.5029 43.0928C34.4843 43.1215 34.4553 43.1456 34.4158 43.1622C34.3744 43.1789 34.3226 43.1933 34.2564 43.2053C34.1903 43.2174 34.1052 43.222 34.0038 43.222C33.9001 43.222 33.8154 43.2174 33.7488 43.2053C33.6827 43.1933 33.6309 43.1789 33.5933 43.1622C33.5538 43.1456 33.5272 43.1215 33.5081 43.0928C33.4915 43.0617 33.4834 43.0303 33.4834 42.9969V34.5885C33.4834 34.401 33.5291 34.2667 33.6223 34.187C33.7132 34.1078 33.8131 34.0671 33.9225 34.0671H34.4363C34.5566 34.0671 34.6579 34.0791 34.7388 34.1032C34.8216 34.125 34.8944 34.1657 34.9586 34.2185C35.0228 34.2713 35.087 34.3482 35.147 34.4445C35.2069 34.5408 35.2711 34.6608 35.3377 34.8076L37.1816 38.8062C37.2958 39.0511 37.4052 39.2892 37.5108 39.5221C37.6164 39.7551 37.7201 39.9834 37.8177 40.2094C37.9152 40.4331 38.0122 40.6563 38.1079 40.8749C38.2054 41.0912 38.2986 41.3121 38.3938 41.5335H38.3999C38.3919 41.1611 38.3852 40.7763 38.3833 40.3752C38.3814 39.9737 38.3814 39.587 38.3814 39.2169V34.2782C38.3814 34.2444 38.3895 34.2134 38.4061 34.187C38.4247 34.1583 38.4537 34.1342 38.4932 34.1125C38.5346 34.0907 38.5883 34.0763 38.6525 34.0666C38.7187 34.0569 38.8057 34.0522 38.9137 34.0522C39.007 34.0522 39.0878 34.0569 39.1563 34.0666C39.2248 34.0763 39.2786 34.0907 39.3157 34.1125C39.3552 34.1342 39.3818 34.1583 39.4009 34.187C39.4175 34.2134 39.4256 34.2449 39.4256 34.2782V42.6723Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4256 34.0522H33.4834V43.2224H39.4256V34.0522Z",
    fill: "url(#paint1_linear_542_299895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 33,
    width: 8,
    height: 11
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0469 38.5069C52.0469 38.0068 52.0117 37.5395 51.9413 37.1093C51.8709 36.6795 51.7544 36.3053 51.5898 35.9876C51.4252 35.6722 51.2068 35.4244 50.9328 35.2466C50.6569 35.0692 50.3182 34.9803 49.9148 34.9803C49.5094 34.9803 49.1707 35.0762 48.8967 35.2679C48.6227 35.4596 48.3986 35.7143 48.2288 36.032C48.0566 36.3521 47.9343 36.7239 47.8606 37.1514C47.7864 37.5765 47.7498 38.023 47.7498 38.4926C47.7498 39.0136 47.785 39.4906 47.8535 39.9273C47.922 40.3668 48.0366 40.7429 48.1993 41.0606C48.3601 41.376 48.5789 41.6214 48.8506 41.7965C49.1227 41.9715 49.4652 42.0604 49.8757 42.0604C50.2849 42.0604 50.6274 41.9646 50.9047 41.7729C51.1825 41.5811 51.4061 41.3241 51.5764 40.9971C51.7448 40.6725 51.8671 40.2937 51.9389 39.8662C52.0117 39.4397 52.0469 38.9863 52.0469 38.5069ZM53.035 38.4254C53.035 39.1428 52.9684 39.7879 52.8352 40.3627C52.7001 40.9374 52.5003 41.426 52.2353 41.8303C51.9689 42.2323 51.6359 42.543 51.2339 42.7602C50.8324 42.9774 50.3643 43.0849 49.8291 43.0849C49.3016 43.0849 48.8463 42.9867 48.4614 42.788C48.0747 42.5893 47.7583 42.2994 47.5067 41.9211C47.255 41.5427 47.0681 41.0726 46.9458 40.5118C46.8216 39.9509 46.7607 39.3058 46.7607 38.5769C46.7607 37.878 46.8273 37.2426 46.9605 36.6721C47.0956 36.102 47.2954 35.618 47.5638 35.2183C47.8302 34.821 48.1651 34.5126 48.567 34.2953C48.9666 34.0781 49.4352 33.9707 49.9718 33.9707C50.488 33.9707 50.938 34.0689 51.321 34.2652C51.7039 34.4616 52.0241 34.7464 52.2776 35.1229C52.5331 35.499 52.7239 35.9644 52.8476 36.5206C52.9722 37.0745 53.035 37.7104 53.035 38.4254Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.036 33.9712H46.7617V43.0854H53.036V33.9712Z",
    fill: "url(#paint2_linear_542_299895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 40,
    width: 7,
    height: 3
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1642 41.6176L45.9118 40.1102C46.025 40.0805 46.1421 40.1528 46.1463 40.2667L46.182 41.2175C46.1863 41.3314 46.0317 41.3361 45.9189 41.3666L40.2041 42.9134C40.0914 42.944 40.04 42.8504 40.0372 42.7365L40.0139 41.8714C40.0105 41.7575 40.051 41.6473 40.1642 41.6176Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1855 40.0801H40.0098V42.9435H46.1855V40.0801Z",
    fill: "url(#paint3_linear_542_299895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 36,
    width: 7,
    height: 4
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1642 38.5039L45.9118 36.9964C46.025 36.9668 46.1421 37.039 46.1463 37.1529L46.182 38.1037C46.1863 38.2177 46.0317 38.2223 45.9189 38.2528L40.2041 39.7997C40.0914 39.8302 40.04 39.7367 40.0372 39.6228L40.0139 38.7576C40.0105 38.6437 40.051 38.5335 40.1642 38.5039Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1855 36.9668H40.0098V39.8303H46.1855V36.9668Z",
    fill: "url(#paint4_linear_542_299895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 33,
    width: 7,
    height: 4
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1642 35.3906L45.9118 33.8831C46.025 33.8535 46.1421 33.9257 46.1463 34.0397L46.182 34.9904C46.1863 35.1044 46.0317 35.109 45.9189 35.1391L40.2041 36.6859C40.0914 36.7165 40.04 36.6229 40.0372 36.509L40.0139 35.6439C40.0105 35.5304 40.051 35.4202 40.1642 35.3906Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1855 33.8535H40.0098V36.717H46.1855V33.8535Z",
    fill: "url(#paint5_linear_542_299895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 37,
    width: 2,
    height: 3
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9043 39.6176V38.0231C48.9043 37.9402 48.9219 37.8786 48.9576 37.837C48.9928 37.7953 49.0389 37.7749 49.0955 37.7749C49.1531 37.7749 49.2002 37.7953 49.2359 37.836C49.2716 37.8773 49.2901 37.9393 49.2901 38.0231V39.6176C49.2901 39.7015 49.272 39.764 49.2359 39.8052C49.2002 39.8469 49.1531 39.8673 49.0955 39.8673C49.0404 39.8673 48.9947 39.8464 48.9585 39.8047C48.9224 39.7631 48.9043 39.7005 48.9043 39.6176Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2896 37.7749H48.9043V39.8677H49.2896V37.7749Z",
    fill: "url(#paint6_linear_542_299895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_542_299895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 37,
    width: 3,
    height: 3
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2132 38.0667V38.1287C50.284 38.0097 50.3621 37.9231 50.4458 37.8675C50.53 37.8119 50.6266 37.7846 50.736 37.7846C50.8425 37.7846 50.9372 37.8138 51.0214 37.8726C51.1051 37.931 51.1674 38.0139 51.2088 38.1213C51.2355 38.1838 51.2526 38.251 51.2607 38.3241C51.2683 38.3964 51.2721 38.4886 51.2721 38.6011V39.5528C51.2721 39.6552 51.2536 39.7325 51.2164 39.7848C51.1798 39.8372 51.1313 39.8636 51.0723 39.8636C51.0124 39.8636 50.9634 39.8367 50.9258 39.783C50.8887 39.7292 50.8696 39.6524 50.8696 39.5528V38.7002C50.8696 38.5321 50.8511 38.4029 50.814 38.3135C50.7774 38.2246 50.7036 38.1801 50.5933 38.1801C50.5219 38.1801 50.4562 38.207 50.3968 38.2612C50.3378 38.3154 50.2945 38.3904 50.2674 38.4853C50.2479 38.5613 50.2374 38.7034 50.2374 38.9123V39.5528C50.2374 39.6565 50.2184 39.7339 50.1803 39.7853C50.1428 39.8372 50.0938 39.8631 50.0343 39.8631C49.9762 39.8631 49.9287 39.8362 49.8911 39.7825C49.854 39.7288 49.835 39.6519 49.835 39.5523V38.0741C49.835 37.9768 49.8516 37.9041 49.8849 37.8559C49.9187 37.8078 49.9639 37.7837 50.0219 37.7837C50.0571 37.7837 50.0895 37.7943 50.1175 37.8156C50.1461 37.837 50.1689 37.8689 50.186 37.911C50.2046 37.9537 50.2132 38.006 50.2132 38.0667Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_542_299895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2721 37.7842H49.8359V39.8627H51.2721V37.7842Z",
    fill: "url(#paint7_linear_542_299895)"
  }))), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1127 37.4984C49.0566 37.4984 49.0086 37.4808 48.9681 37.4456C48.9272 37.4104 48.9072 37.3609 48.9072 37.2979C48.9072 37.2437 48.9267 37.1979 48.9657 37.159C49.0047 37.1201 49.0528 37.1011 49.1099 37.1011C49.167 37.1011 49.2155 37.1201 49.2555 37.1585C49.2959 37.1969 49.3154 37.2433 49.3154 37.2984C49.3154 37.3604 49.2954 37.4095 49.2555 37.4452C49.2145 37.4804 49.1674 37.4984 49.1127 37.4984Z",
    fill: "#00E9E7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_542_299895",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_542_299895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_542_299895",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_299895",
    x1: 33.4834,
    y1: 38.6375,
    x2: 39.4258,
    y2: 38.6375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_542_299895",
    x1: 36.5395,
    y1: 34.4167,
    x2: 36.3822,
    y2: 42.6659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_542_299895",
    x1: 50.1446,
    y1: 34.6075,
    x2: 49.6508,
    y2: 42.9068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_542_299895",
    x1: 40.2047,
    y1: 41.7452,
    x2: 45.9649,
    y2: 41.2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_542_299895",
    x1: 40.2047,
    y1: 38.6318,
    x2: 45.9649,
    y2: 38.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_542_299895",
    x1: 40.2047,
    y1: 35.5187,
    x2: 45.9649,
    y2: 35.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_542_299895",
    x1: 49.1025,
    y1: 37.8961,
    x2: 49.093,
    y2: 39.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_542_299895",
    x1: 50.5346,
    y1: 37.9264,
    x2: 50.5738,
    y2: 39.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_299895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.32,
    height: 71.422,
    fill: "white",
    transform: "translate(6.59961 3.09814)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_542_299895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.552,
    height: 9.36934,
    fill: "white",
    transform: "translate(33.4834 33.8535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.aa19a2273421b67120f01832a03a6bdb.svg";
export { ForwardRef as ReactComponent };